import api from './index'

export default async function getContactOwner(contact, country) {
  try {
    const { data } = await api.post(`/api/${country}/contact-owner`, contact)
    return data
  } catch (error) {
    return {}
  }
}

export async function getContactFromToken(token) {
  try {
    const { data } = await api.get(`/api/contact-token/${token}`)
    return data
  } catch (error) {
    throw new Error(error)
  }
}
